import { ErrorName, transformErrorName, transformErrorUiProps } from 'errors';

import HttpService from 'services/HttpService';

import { API_URLS } from 'constants/apiUrls';
import { getPublicUrl } from 'constants/config';

import { FeatureIntroCodes } from 'models/Doctor';
import { PhoneNumberCarrierDetails } from 'models/PhoneNumberDetails';

const httpService = new HttpService('user');

export class UserFetcher {
  static async logout(): Promise<{}> {
    return await httpService.get({
      url: API_URLS.LOGOUT,
      transformError: transformErrorUiProps('Failed to logout'),
      overrideBaseURL: getPublicUrl('loginApi')
    });
  }

  static async lookUpPhoneDetails(phoneNumber: string): Promise<PhoneNumberCarrierDetails> {
    return await httpService.get({ url: API_URLS.LOOKUP_PHONE_DETAILS(phoneNumber) });
  }

  static async sendSupportRequest(message: string): Promise<void> {
    return await httpService.post({ url: API_URLS.SEND_SUPPORT_REQUEST, data: { message } });
  }

  static async updateIntroFinished(feature: FeatureIntroCodes): Promise<void> {
    return await httpService.post({
      url: API_URLS.UPDATE_FEATURE_FINISHED,
      transformError: transformErrorName(ErrorName.UpdateIntroFeatureFailed),
      data: { code: feature }
    });
  }
}
